import {
  Box,
  Grid,
  TextField,
  createTheme,
  ThemeProvider,
  Stack,
  useTheme,
  useMediaQuery,
  Autocomplete,
  CircularProgress,
  Avatar,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import MUIDataTable from "mui-datatables";

import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import StatusAlert from "../../../StatusAlertList/StatusAlert";
import { LeadAgentsSettingsApi } from "../../../Data/axios";
import config from "../../../Data/AuthUser";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function LeadAgents() {
  const [open, setOpen] = React.useState(false);
  const [updateLead, setUpdateLead] = React.useState("");
  const [lead, setLead] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pageValue, setPageValue] = useState(1);

  const [rowCountValue, setRowCountValue] = useState(0);
  const [LeadAgents, setLeadAgents] = useState([]);
  const [data, setData] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [update, setUpdate] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));

  const isMd = useMediaQuery(theme.breakpoints.down("md"));
  const isLg = useMediaQuery(theme.breakpoints.down("lg"));
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const handleClickUpdate = () => {
    setUpdate(true);
  };
  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };
  const handleUpdateClose = () => {
    setUpdate(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getData();
  }, [rowsPerPage, pageValue]);

  async function getData() {
    const response = await LeadAgentsSettingsApi.getAll(pageValue, rowsPerPage);

    setLeadAgents(response?.data);
    setRowCountValue(response?.total);
    setRowsPerPage(response?.per_page);
  }
  const [agentsMain, setAgentsMain] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState({
    empid: null,
  });

  // Fetch agents from the API
  useEffect(() => {
    const fetchAgents = async () => {
      setLoading(true);
      try {
        const data = await LeadAgentsSettingsApi.getEmployee();
        setAgentsMain(data || []); // Assuming `data.data` contains the agents array
      } catch (error) {
        console.error("Error fetching agents:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAgents();
  }, []);
  const columns = [
    {
      name: "agents",
      label: "Lead Agent",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Lead Agent
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          const ticketId = tableMeta.rowData[0];

          const fullRecord = LeadAgents.find(
            (item) => item.agents === ticketId
          );

          if (!fullRecord) {
            return <div>Loading...</div>;
          }

          const imageUrl = `${config.apiImageUrl}${fullRecord.image}`;

          return (
            <div
              key={value.id}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={imageUrl}
                alt="Agent"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: "10px",
                }}
              />
              <div>
                <div style={{ fontWeight: "bold", color: "#333" }}>
                  {fullRecord.username || ""}
                </div>
                <div style={{ color: "gray" }}>{fullRecord.role || ""}</div>
              </div>
            </div>
          );
        },
      },
    },

    {
      name: "id",
      label: "Actions",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right", // Aligns header to the left
                paddingRight: "70px", // Add padding for starting point
                borderBottom: "1px solid #ddd",
              }}
            >
              Actions
            </th>
          );
        },
        customBodyRender: (value) => (
          <div
            key={value}
            style={{
              display: "flex",
              justifyContent: "flex-end", // Aligns content to the left
              alignItems: "center",
              paddingLeft: "20px", // Add padding for starting point
            }}
          >
            <Stack
              spacing={2}
              direction="row"
              sx={{
                justifyContent: "flex-end",
                "& .MuiButton-root": {
                  margin: "0 4px",
                },
              }}
            >
              <Button variant="outlined" onClick={() => handleDelete(value)}>
                <DeleteForeverIcon /> Delete
              </Button>
            </Stack>
          </div>
        ),
      },
    },
  ];

  async function handleDelete(id) {
    await LeadAgentsSettingsApi.delete(id);
    getData();
    showAlert(" Deleted successfully", "warning");
  }

  // Save Lead Sourse
  // console.log(selectedAgent.name, "selected gage ");

  const item = {
    agents: selectedAgent.empid,
  };

  async function SaveDate() {
    try {
      const formData = new FormData();

      // Append each item to the FormData object
      for (const key in item) {
        if (item[key] !== undefined && item[key] !== null) {
          formData.append(key, item[key]);
        }
      }
      await LeadAgentsSettingsApi.add(formData);
      showAlert(" Added Successfully!", "success");
      getData();
      setOpen(false);
    } catch (error) {
      console.error("Fetch error:", error);
      showAlert("Failed to add Lead Source", "error");
    }

    // }
  }

  const rowsPerPageOptions = [5, 10, 25, 100];
  const options = {
    selectableRows: "none",
    selectToolbarPlacement: "none",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: rowsPerPageOptions,
    onChangeRowsPerPage: (newRowsPerPage) => {
      setRowsPerPage(newRowsPerPage);
      setPageValue(0);
    },
    totalPages: Math.ceil(rowCountValue / rowsPerPage), // Adding total pages
    onChangePage: (currentPage) => {
      setPageValue(currentPage + 1);
    },
    customFooter: (
      rowCount,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage
    ) => {
      const totalPages = Math.ceil(rowCountValue / rowsPerPage);

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <div>
            <span>
              Showing {page * rowsPerPage + 1} -{" "}
              {Math.min(rowCountValue, (page + 1) * rowsPerPage)} of{" "}
              {rowCountValue} entries
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div>
              <label htmlFor="rowsPerPage">Rows per page: </label>
              <select
                id="rowsPerPage"
                value={rowsPerPage}
                onChange={(e) => changeRowsPerPage(Number(e.target.value))}
              >
                {rowsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ padding: "10px", textAlign: "right" }}>
              Page {page + 1} of {totalPages}
              <Button
                variant="outlined"
                onClick={() => changePage(page - 1)}
                disabled={page === 0}
                sx={{
                  margin: "0 5px",
                  color: "#1d82f5",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                    border: "1px solid black",
                  },
                }}
              >
                Previous
              </Button>
              <Button
                variant="outlined"
                onClick={() => changePage(page + 1)}
                disabled={page + 1 === totalPages}
                sx={{
                  color: "#1d82f5",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                    border: "1px solid black",
                  },
                }}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      );
    },
    tableBody: {
      style: {
        maxHeight: `${rowsPerPage * 50}px`,
        overflow: "auto",
        marginLeft: "5px",
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
        boxShadow: "none",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
      },
    },
    rows: {
      style: {},
      selectableRowsOnClick: true,
    },
  };
  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  return (
    <>
      <List style={{ background: "none", padding: 5 }}>
        <StatusAlert
          open={alertOpen}
          setOpen={setAlertOpen}
          message={alertMessage}
          severity={alertSeverity}
        />
        <ListItemText style={{ background: "none", margin: 5 }}>
          <React.Fragment>
            <Box
              onClick={handleClickOpen}
              sx={{
                backgroundColor: "#1d82f5",
                "&:hover": { backgroundColor: "orange" },
                textAlign: "center",
                padding: "10px",
                marginLeft: "10px",
                height: "40px",
                width: "170px",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                borderRadius: "4px",
                fontSize: "15px",
                fontFamily: "sans-serif",
                cursor: "pointer",
              }}
            >
              <AddCircleIcon /> Add Lead Agent
            </Box>
            <Dialog
              fullWidth
              maxWidth="sm"
              open={open}
              onClose={handleClose}
              TransitionComponent={Transition}
              PaperProps={{
                style: {
                  position: "absolute",
                  background: "#fff",
                  top: "0",
                  backgroundColor: "white",
                  maxHeight: "95%",
                  margin: "auto",
                  overflowX: "hidden",
                  zIndex: 1200,
                },
              }}
            >
              <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                  >
                    <CloseIcon fontSize="large" />
                  </IconButton>
                  <Typography
                    sx={{ ml: 2, flex: 1, fontSize: "18px" }}
                    component="div"
                  >
                    Add Agent
                  </Typography>
                </Toolbar>
              </AppBar>
              <Box
                component="form"
                sx={{
                  p: 2,
                  bgcolor: "#fff",
                  borderRadius: 1,
                  boxShadow: 1,
                }}
              >
                <Grid
                  container
                  spacing={2}
                  style={{ color: "black", margin: "10px" }}
                >
                  {/* <Grid item xs={12} sm={10}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Lead Agent
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          placeholder="Enter Agent Name"
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          onChange={(e) => setLead(e.target.value)}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid> */}
                  <Grid item xs={11} sm={6} md={4.2}>
                    <Stack direction="column">
                      <Typography> Lead Agent</Typography>

                      <Autocomplete
                        options={agentsMain}
                        getOptionLabel={(option) => option.empid || ""}
                        value={selectedAgent}
                        onChange={(event, value) => setSelectedAgent(value)}
                        loading={loading}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Search for an agent"
                            variant="outlined"
                            fullWidth
                            sx={{
                              border: 1,
                              borderRadius: 1,
                              width: "100%",
                              "& .MuiOutlinedInput-root": {
                                borderColor: "black",
                                "&:hover fieldset": {
                                  borderColor: "black",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "black",
                                },
                              },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              style: { color: "black" },
                              endAdornment: (
                                <>
                                  {loading ? (
                                    <CircularProgress size={20} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        renderOption={(props, option) => {
                          const imageUrl = `${config.apiImageUrl}${option.image}`;
                          return (
                            <Box
                              {...props}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                padding: "10px",
                                "&:hover": { backgroundColor: "#f5f5f5" },
                              }}
                            >
                              <Avatar
                                src={imageUrl}
                                alt={option.name}
                                sx={{
                                  width: 30,
                                  height: 30,
                                  marginRight: "10px",
                                }}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Typography>
                                  {option.name}
                                  {option.isYou && (
                                    <Typography
                                      component="span"
                                      sx={{
                                        fontSize: "0.8rem",
                                        fontWeight: "normal",
                                        color: "#888",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      (It’s you)
                                    </Typography>
                                  )}
                                </Typography>
                                <Typography>{option.empid}</Typography>
                              </div>
                            </Box>
                          );
                        }}
                        sx={{
                          width: "300px",
                          "& .MuiAutocomplete-popupIndicator": {
                            display: "none",
                          },
                          "& .MuiAutocomplete-clearIndicator": {
                            display: "none",
                          },
                        }}
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "10px 0 20px 20px" }}>
                  <Grid item sx={11} className="messageFooter">
                    <Box className="response" onClick={SaveDate}>
                      Save
                    </Box>
                    <Box className="cancel" onClick={handleClose}>
                      Cancel
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Dialog>
          </React.Fragment>
        </ListItemText>
        <Divider />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ListItemText
              style={{ background: "white", margin: 0, maxWidth: "100%" }}
            >
              <ThemeProvider theme={getTheme()}>
                <Box
                  sx={{
                    maxWidth: "100%",
                  }}
                >
                  <MUIDataTable
                    title={
                      <span
                        style={{
                          fontWeight: 700,
                          fontSize: "1.5rem",
                          color: "#333",
                        }}
                      >
                        Lead Agents
                      </span>
                    }
                    data={LeadAgents}
                    columns={columns}
                    options={options}
                  />
                </Box>
              </ThemeProvider>
            </ListItemText>
          </Grid>
        </Grid>
      </List>
    </>
  );
}

export default LeadAgents;
